<template>
    <div class="onboardingscreen">
        <div class="onboardingscreen__head">
            <div class="onboardingscreen__head-title typographies-display-brand-large">
                {{ $l10n.__('Bienvenue 🎉') }}
            </div>

            <CompassButton
                v-if="isVariationDemoButtonAtTop"
                :label="$l10n.__('Demander une démo')"
                @click="redirectTo('https://go.sellsy.com/demande-de-rendez-vous', '_blank')"
            >
            </CompassButton>
        </div>
        <OnboardingScreen :columns="columns" :is-loading="isLoading" />
    </div>
</template>

<script>
import OnboardingScreen from 'vcomponents/onboarding/OnboardingScreen.vue';
import onboardingScreenService from 'api/onboarding/onboardingScreenService';
import Feature from "Services/Feature";

export default {
    components: { OnboardingScreen },
    data() {
        return {
            isLoading: false,
            columns: [],
        };
    },
    created() {
        this.getCardsData();
    },
    computed: {
        isVariationDemoButtonAtTop() {
            return Feature.isVariation('onboarding-screen-abtest-button','demo-button-at-top');
        },
    },
    methods: {
        redirectTo(url, target) {
            window.open(url, target);
        },
        async getCardsData() {
            this.isLoading = true;

            await onboardingScreenService
                .getCards()
                .then((response) => {
                    this.columns = response.data.columns;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.page-onboarding-onboarding_screen {
    #sellsy_app {
        background-color: #fff !important;
    }
}
</style>
<style lang="scss" scoped>
.onboardingscreen {
    padding: var(--spacing-1) var(--spacing-3);

    &__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: var(--spacing-4);
    }
}
</style>
